import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue";
import _imports_0 from '@/assets/images/filecoin-logo.svg';
import _imports_1 from '@/assets/images/icons/open.svg';
import _imports_2 from '@/assets/images/icons/link.svg';
const _hoisted_1 = {
  class: "row"
};
const _hoisted_2 = {
  key: 0,
  class: "col-12"
};
const _hoisted_3 = {
  class: "mt-1 mb-3"
};
const _hoisted_4 = {
  class: "row mb-2"
};
const _hoisted_5 = {
  class: "col-12 text-left fw-extra-bold fsi-16"
};
const _hoisted_6 = {
  class: "row"
};
const _hoisted_7 = {
  class: "col-12 mb-1 mt-2"
};
const _hoisted_8 = {
  class: "row mb-2 mt-3"
};
const _hoisted_9 = {
  class: "col-12 text-left fw-extra-bold fsi-16"
};
const _hoisted_10 = {
  class: "row"
};
const _hoisted_11 = {
  class: "col-12 mb-3 mt-2"
};
const _hoisted_12 = {
  key: 0,
  class: "row mt-4"
};
const _hoisted_13 = {
  class: "col-7 text-left fw-medium fsi-14 d-flex align-items-center"
};
const _hoisted_14 = {
  class: "mr-1"
};
const _hoisted_15 = {
  style: {
    "display": "inline-block",
    "transform": "translateY(2px)"
  }
};
const _hoisted_16 = {
  class: "col-5 text-right fw-medium fsi-14 opacity-08"
};
const _hoisted_17 = {
  class: "text-right fw-medium fsi-14"
};
const _hoisted_18 = {
  key: 1,
  class: "row mt-4"
};
const _hoisted_19 = {
  class: "col-6 text-left fw-medium fsi-14 d-flex align-items-center"
};
const _hoisted_20 = {
  class: "mr-1"
};
const _hoisted_21 = {
  style: {
    "display": "inline-block",
    "transform": "translateY(2px)"
  }
};
const _hoisted_22 = {
  class: "col-6 text-right fw-medium fsi-14 opacity-08"
};
const _hoisted_23 = {
  class: "text-right fw-medium fsi-14"
};
const _hoisted_24 = {
  class: "row mt-3"
};
const _hoisted_25 = {
  class: "col-6 text-left fw-medium fsi-14"
};
const _hoisted_26 = {
  class: "col-6 text-right fw-medium fsi-14 opacity-08"
};
const _hoisted_27 = {
  class: "text-right fw-medium fsi-14"
};
const _hoisted_28 = {
  key: 1,
  class: "row mt-4"
};
const _hoisted_29 = {
  class: "col-12"
};
const _hoisted_30 = {
  class: "d-flex align-items-center mb-1",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_31 = {
  class: "mr-2"
};
const _hoisted_32 = {
  class: "form-group mb-2"
};
const _hoisted_33 = {
  class: "position-relative"
};
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", {
  class: "position-absolute d-flex justify-content-center align-items-center h-100",
  style: {
    "left": "0",
    "z-index": "100",
    "width": "4rem"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "1.8rem"
  }
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {
    "width": "29px",
    "height": "29px"
  },
  alt: ""
})])], -1);
const _hoisted_35 = {
  class: "position-absolute d-flex justify-content-center align-items-center h-100",
  style: {
    "right": "0",
    "width": "6rem"
  }
};
const _hoisted_36 = ["disabled"];
const _hoisted_37 = {
  key: 2,
  class: "row mb-5"
};
const _hoisted_38 = {
  class: "col-12 mt-3 mb-2"
};
const _hoisted_39 = {
  class: "mt-1 col-12 mt-3"
};
const _hoisted_40 = {
  class: "pl-2 pr-2"
};
const _hoisted_41 = {
  key: 3,
  class: "row mt-4"
};
const _hoisted_42 = {
  class: "col-12 text-left fw-extra-bold fsi-16"
};
const _hoisted_43 = {
  key: 4,
  class: "row mt-4"
};
const _hoisted_44 = {
  class: "col-7 text-left fw-medium fsi-14 d-flex align-items-center"
};
const _hoisted_45 = {
  class: "mr-1"
};
const _hoisted_46 = {
  style: {
    "display": "inline-block",
    "transform": "translateY(2px)"
  }
};
const _hoisted_47 = {
  class: "col-5 text-right fw-medium fsi-14 opacity-08"
};
const _hoisted_48 = {
  class: "text-right fw-medium fsi-14"
};
const _hoisted_49 = {
  key: 5,
  class: "row mt-3"
};
const _hoisted_50 = {
  class: "col-6 text-left fw-medium fsi-14"
};
const _hoisted_51 = {
  class: "col-6 text-right fw-medium fsi-14 opacity-08"
};
const _hoisted_52 = {
  class: "text-right fw-medium fsi-14"
};
const _hoisted_53 = {
  key: 6,
  class: "row mb-4"
};
const _hoisted_54 = {
  class: "col-12 mt-3 mb-3"
};
const _hoisted_55 = {
  class: "col-12 mt-3"
};
const _hoisted_56 = {
  class: "pl-2 pr-2"
};
const _hoisted_57 = {
  key: 7,
  class: "row mt-5"
};
const _hoisted_58 = {
  class: "col-12"
};
const _hoisted_59 = {
  key: 0,
  class: "d-flex align-items-center justify-content-between",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_60 = {
  class: "mr-2",
  style: {
    "min-width": "180px"
  }
};
const _hoisted_61 = {
  class: "text-right fw-medium fsi-14"
};
const _hoisted_62 = {
  class: "fw-bold"
};
const _hoisted_63 = {
  class: "row mt-3"
};
const _hoisted_64 = {
  class: "col-5 text-left fw-medium fsi-14"
};
const _hoisted_65 = {
  class: "col-7 text-right fw-medium fsi-14 opacity-08"
};
const _hoisted_66 = {
  class: "text-right fw-medium fsi-14"
};
const _hoisted_67 = {
  class: "row mt-3"
};
const _hoisted_68 = {
  class: "col-7 text-left fw-medium fsi-14"
};
const _hoisted_69 = {
  style: {
    "display": "inline-block",
    "transform": "translateY(2px)"
  }
};
const _hoisted_70 = /*#__PURE__*/_createElementVNode("span", {
  style: {
    "display": "inline-block",
    "width": "5px",
    "height": "5px",
    "background-color": "#3ac72f",
    "border-radius": "5px",
    "transform": "translateY(-2px)"
  },
  class: "mr-1"
}, null, -1);
const _hoisted_71 = /*#__PURE__*/_createElementVNode("span", {
  style: {
    "display": "inline-block",
    "width": "5px",
    "height": "5px",
    "background-color": "#3ac72f",
    "border-radius": "5px",
    "transform": "translateY(-2px)"
  },
  class: "mr-1"
}, null, -1);
const _hoisted_72 = {
  key: 0
};
const _hoisted_73 = /*#__PURE__*/_createElementVNode("span", {
  style: {
    "display": "inline-block",
    "width": "5px",
    "height": "5px",
    "background-color": "#3ac72f",
    "border-radius": "5px",
    "transform": "translateY(-2px)"
  },
  class: "mr-1"
}, null, -1);
const _hoisted_74 = {
  class: "col-5 text-right fw-medium fsi-14 opacity-08"
};
const _hoisted_75 = {
  class: "text-right fw-medium fsi-14"
};
const _hoisted_76 = {
  key: 8,
  class: "row mt-3"
};
const _hoisted_77 = {
  class: "col-8 text-left fw-medium fsi-14"
};
const _hoisted_78 = {
  class: "col-4 text-right fw-medium fsi-14 opacity-08"
};
const _hoisted_79 = {
  class: "text-right fw-medium fsi-14"
};
const _hoisted_80 = {
  key: 9,
  class: "row mt-3"
};
const _hoisted_81 = {
  class: "col-8 text-left fw-medium fsi-14"
};
const _hoisted_82 = {
  class: "col-4 text-right fw-medium fsi-14 opacity-08"
};
const _hoisted_83 = {
  class: "text-right fw-medium fsi-14"
};
const _hoisted_84 = {
  key: 10,
  class: "row mt-3"
};
const _hoisted_85 = {
  class: "col-8 text-left fw-medium fsi-14"
};
const _hoisted_86 = {
  class: "col-4 text-right fw-medium fsi-14 opacity-08"
};
const _hoisted_87 = {
  class: "text-right fw-medium fsi-14"
};
const _hoisted_88 = {
  class: "row mt-3"
};
const _hoisted_89 = {
  class: "col-7 text-left fw-medium fsi-14"
};
const _hoisted_90 = {
  style: {
    "display": "inline-block",
    "transform": "translateY(2px)"
  }
};
const _hoisted_91 = {
  class: "col-5 text-right fw-medium fsi-14 opacity-08"
};
const _hoisted_92 = {
  class: "text-right fw-medium fsi-14"
};
const _hoisted_93 = /*#__PURE__*/_createElementVNode("img", {
  style: {
    "width": "16px",
    "margin-bottom": "1px",
    "color": "white",
    "cursor": "pointer"
  },
  src: _imports_1,
  alt: ""
}, null, -1);
const _hoisted_94 = {
  class: "mt-4"
};
const _hoisted_95 = {
  key: 1,
  class: "d-flex align-items-center"
};
const _hoisted_96 = {
  key: 0,
  class: "ml-2 cursor-pointer icon-hover"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Tip = _resolveComponent("Tip");
  const _component_RadioBtn = _resolveComponent("RadioBtn");
  const _component_Tooltip = _resolveComponent("Tooltip");
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item");
  const _component_IndicatorValue = _resolveComponent("IndicatorValue");
  const _component_i_skeleton = _resolveComponent("i-skeleton");
  const _component_el_slider = _resolveComponent("el-slider");
  const _component_el_tooltip = _resolveComponent("el-tooltip");
  const _component_IndicatorRay = _resolveComponent("IndicatorRay");
  const _component_el_button = _resolveComponent("el-button");
  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_ctx.isExceedMaxDebtRate && !_ctx.currentLoading ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_Tip, {
    level: "warring"
  }, {
    btnGroup: _withCtx(() => [_createElementVNode("a", {
      class: "mr-4 cursor-pointer",
      style: {
        "text-decoration": "underline"
      },
      onClick: _cache[0] || (_cache[0] = (...args) => $options.goToRepay && $options.goToRepay(...args))
    }, _toDisplayString(_ctx.$t('farm.console.Gotorepay')), 1)]),
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('subpool.Yourcurrentdebtratiorateexceedsthemaximumdebtratio').replace('$$$', `${$options.formatUnits(_ctx.debtRatio, 2)}%`).replace('$2$$', `${$options.formatUnits(_ctx.poolMaxDebtRatio, 2)}%`)) + " ", 1)]),
    _: 1
  })])])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('farm.console.Choosethewayyoulike')), 1)]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createVNode(_component_RadioBtn, {
    disabled: $data.loading,
    "tab-arr": $data.tabOptions1,
    modelValue: $data.radio1,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.radio1 = $event)
  }, null, 8, ["disabled", "tab-arr", "modelValue"])])]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('farm.console.Whatinterestratedoyoupreferforborrowing')), 1)]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createVNode(_component_RadioBtn, {
    disabled: $data.loading,
    "tab-arr": $data.tabOptions,
    modelValue: $data.radio3,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.radio3 = $event)
  }, null, 8, ["disabled", "tab-arr", "modelValue"])])]), $data.radio1 === 'By Amount' ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [$data.radio3 === 'Variable' ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t('subpool.withdrawLoadAmount')), 1), _createElementVNode("span", _hoisted_15, [_createVNode(_component_Tooltip, null, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('subpool.withdrawLoadAmount')), 1)]),
    _: 1
  })])]), _createElementVNode("div", _hoisted_16, [_createVNode(_component_i_skeleton, {
    loading: _ctx.currentLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_17, [_createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "70%"
      }
    })])]),
    default: _withCtx(() => [_createVNode(_component_IndicatorValue, {
      "old-value": _ctx.withdrawLoadAmount,
      "new-value": _ctx.withdrawLoadAmount
    }, null, 8, ["old-value", "new-value"])]),
    _: 1
  }, 8, ["loading"])])])) : _createCommentVNode("", true), $data.radio3 === 'Stable' ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t('farm.console.OutstandingStableDebt')), 1), _createElementVNode("span", _hoisted_21, [_createVNode(_component_Tooltip, null, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('farm.console.OutstandingStableDebtTip')), 1)]),
    _: 1
  })])]), _createElementVNode("div", _hoisted_22, [_createVNode(_component_i_skeleton, {
    loading: _ctx.currentLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_23, [_createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "70%"
      }
    })])]),
    default: _withCtx(() => [_createVNode(_component_IndicatorValue, {
      "old-value": _ctx.stableDebtValue,
      "new-value": _ctx.stableDebtValue
    }, null, 8, ["old-value", "new-value"])]),
    _: 1
  }, 8, ["loading"])])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$t('farm.console.MaximumBorrowingLimit')), 1), _createElementVNode("div", _hoisted_26, [_createVNode(_component_i_skeleton, {
    loading: _ctx.currentLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_27, [_createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "70%"
      }
    })])]),
    default: _withCtx(() => [_createVNode(_component_IndicatorValue, {
      "old-value": _ctx.availableBorrowingAmount,
      "new-value": _ctx.availableBorrowingAmount
    }, null, 8, ["old-value", "new-value"])]),
    _: 1
  }, 8, ["loading"])])])], 64)) : _createCommentVNode("", true), $data.radio1 === 'By Amount' ? (_openBlock(), _createElementBlock("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, [_createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.$t('farm.console.Youareborrowing')), 1)]), _createElementVNode("div", _hoisted_32, [_createElementVNode("div", _hoisted_33, [_hoisted_34, _createElementVNode("div", _hoisted_35, [_createElementVNode("button", {
    type: "button",
    class: "btn btn-info btn-sm btn-max",
    style: {
      "padding": "4px 15px"
    },
    onClick: _cache[3] || (_cache[3] = (...args) => $options.borrowMax && $options.borrowMax(...args))
  }, _toDisplayString(_ctx.$t("max")), 1)]), _withDirectives(_createElementVNode("input", {
    class: "form-control shadow-none stake-input",
    onInput: _cache[4] || (_cache[4] = (...args) => $options.adjustBorrowingValueChange && $options.adjustBorrowingValueChange(...args)),
    disabled: $data.loading,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.adjustBorrowingValue = $event),
    type: "number",
    placeholder: "0.00",
    autocomplete: "off",
    id: "fname2",
    required: ""
  }, null, 40, _hoisted_36), [[_vModelText, $data.adjustBorrowingValue]])])])])])) : _createCommentVNode("", true), $data.radio1 === 'By Amount' ? (_openBlock(), _createElementBlock("div", _hoisted_37, [_createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.$t('farm.console.CurrentLeverage')), 1), _createElementVNode("div", _hoisted_39, [_createVNode(_component_i_skeleton, {
    loading: _ctx.currentLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_40, [_createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "100%"
      }
    }), _createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "100%"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", {
      style: _normalizeStyle([{
        "background-color": "#fafafa",
        "border-radius": "5px"
      }, {
        paddingBottom: _ctx.guaranteeLeverage > 10000n ? '12px' : '0px'
      }]),
      class: "pl-2 pr-2"
    }, [_createVNode(_component_el_slider, {
      disabled: "",
      "format-tooltip": $options.sliderFormatTip,
      placement: "top",
      max: _ctx.marksMax,
      modelValue: $data.sliderValue,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.sliderValue = $event),
      marks: _ctx.marks
    }, null, 8, ["format-tooltip", "max", "modelValue", "marks"]), _createVNode(_component_el_tooltip, {
      class: "box-item",
      effect: "dark",
      content: "Top Left prompts info",
      placement: "top"
    }, {
      default: _withCtx(() => [_ctx.guaranteeLeverage > 10000n ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "guaranteeLeverageSlider",
        style: _normalizeStyle({
          width: _ctx.guaranteeLeverageSliderWidth
        })
      }, null, 4)) : _createCommentVNode("", true)]),
      _: 1
    })], 4)]),
    _: 1
  }, 8, ["loading"])])])) : _createCommentVNode("", true), $data.radio1 === 'By Leverage' ? (_openBlock(), _createElementBlock("div", _hoisted_41, [_createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.$t('farm.console.Pleasemakechangestotheleverage')), 1)])) : _createCommentVNode("", true), $data.radio1 === 'By Leverage' ? (_openBlock(), _createElementBlock("div", _hoisted_43, [_createElementVNode("div", _hoisted_44, [_createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.$t('subpool.withdrawLoadAmount')), 1), _createElementVNode("span", _hoisted_46, [_createVNode(_component_Tooltip, null, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('subpool.withdrawLoadAmount')), 1)]),
    _: 1
  })])]), _createElementVNode("div", _hoisted_47, [_createVNode(_component_i_skeleton, {
    loading: _ctx.currentLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_48, [_createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "70%"
      }
    })])]),
    default: _withCtx(() => [_createVNode(_component_IndicatorValue, {
      "old-value": _ctx.withdrawLoadAmount,
      "new-value": _ctx.withdrawLoadAmount
    }, null, 8, ["old-value", "new-value"])]),
    _: 1
  }, 8, ["loading"])])])) : _createCommentVNode("", true), $data.radio1 === 'By Leverage' ? (_openBlock(), _createElementBlock("div", _hoisted_49, [_createElementVNode("div", _hoisted_50, _toDisplayString(_ctx.$t('farm.console.MaximumBorrowingLimit')), 1), _createElementVNode("div", _hoisted_51, [_createVNode(_component_i_skeleton, {
    loading: _ctx.currentLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_52, [_createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "70%"
      }
    })])]),
    default: _withCtx(() => [_createVNode(_component_IndicatorValue, {
      "old-value": _ctx.availableBorrowingAmount,
      "new-value": _ctx.availableBorrowingAmount
    }, null, 8, ["old-value", "new-value"])]),
    _: 1
  }, 8, ["loading"])])])) : _createCommentVNode("", true), $data.radio1 === 'By Leverage' ? (_openBlock(), _createElementBlock("div", _hoisted_53, [_createElementVNode("div", _hoisted_54, _toDisplayString(_ctx.$t('farm.console.TargetLeverage')), 1), _createElementVNode("div", _hoisted_55, [_createVNode(_component_i_skeleton, {
    loading: _ctx.currentLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_56, [_createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "100%"
      }
    }), _createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "100%"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", {
      ref: "main-slider",
      style: _normalizeStyle([{
        "background-color": "#fafafa",
        "border-radius": "5px"
      }, {
        paddingBottom: _ctx.totalLeftGuarantee < _ctx.muLeftWithdrawGuarantee ? '12px' : '0px'
      }]),
      class: _normalizeClass(["pl-2 pr-2", _ctx.sliderChangeClass])
    }, [_createVNode(_component_el_slider, {
      disabled: $data.loading,
      "format-tooltip": $options.sliderFormatTip,
      placement: "top",
      onInput: $options.changeSliderValue,
      max: _ctx.marksMax,
      step: 0.1,
      modelValue: $data.sliderValue,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => $data.sliderValue = $event),
      marks: _ctx.marks
    }, null, 8, ["disabled", "format-tooltip", "onInput", "max", "step", "modelValue", "marks"]), _createVNode(_component_el_tooltip, {
      class: "box-item",
      effect: "dark",
      content: _ctx.$t('subpool.This is the pools collateral section'),
      placement: "top"
    }, {
      default: _withCtx(() => [_ctx.totalLeftGuarantee < _ctx.muLeftWithdrawGuarantee ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "guaranteeLeverageSlider",
        style: _normalizeStyle({
          width: _ctx.otherLeverageSliderWidth
        })
      }, null, 4)) : _createCommentVNode("", true)]),
      _: 1
    }, 8, ["content"])], 6)]),
    _: 1
  }, 8, ["loading"])])])) : _createCommentVNode("", true), $data.radio1 === 'By Leverage' ? (_openBlock(), _createElementBlock("div", _hoisted_57, [_createElementVNode("div", _hoisted_58, [_ctx.youAreBorrowing >= 0n ? (_openBlock(), _createElementBlock("div", _hoisted_59, [_createElementVNode("div", _hoisted_60, _toDisplayString(_ctx.$t('farm.console.Youareborrowing')), 1), _createVNode(_component_i_skeleton, {
    loading: _ctx.currentLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_61, [_createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "50%"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", null, [_createElementVNode("span", _hoisted_62, _toDisplayString($options.formatWalletFilPrice(_ctx.youAreBorrowing)), 1)])]),
    _: 1
  }, 8, ["loading"])])) : _createCommentVNode("", true)])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_63, [_createElementVNode("div", _hoisted_64, _toDisplayString(_ctx.$t('subpool.currentWithdrawLoadAmount')), 1), _createElementVNode("div", _hoisted_65, [_createVNode(_component_i_skeleton, {
    loading: _ctx.currentLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_66, [_createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "50%"
      }
    })])]),
    default: _withCtx(() => [_createVNode(_component_IndicatorValue, {
      "old-value": _ctx.withdrawLoadAmount,
      "new-value": _ctx.afterwithdrawLoadAmount
    }, null, 8, ["old-value", "new-value"])]),
    _: 1
  }, 8, ["loading"])])]), _createElementVNode("div", _hoisted_67, [_createElementVNode("div", _hoisted_68, [_createTextVNode(_toDisplayString($data.radio3 === 'Stable' ? _ctx.$t('farm.console.SingleRemainingBorrowingCapacity') : _ctx.$t('farm.console.RemainingBorrowingCapacity')) + " ", 1), _createElementVNode("span", _hoisted_69, [_createVNode(_component_Tooltip, null, {
    default: _withCtx(() => [_createElementVNode("div", null, [_createElementVNode("div", null, [_hoisted_70, _createElementVNode("span", null, _toDisplayString(_ctx.$t('farm.console.The loan amount cannot exceed the maximum leverage')), 1)]), _createElementVNode("div", null, [_hoisted_71, _createElementVNode("span", null, _toDisplayString(_ctx.$t('farm.console.The loan amount cannot exceed the available liquid funds')), 1)]), $data.radio3 === 'Stable' ? (_openBlock(), _createElementBlock("div", _hoisted_72, [_hoisted_73, _createElementVNode("span", null, _toDisplayString(_ctx.$t('farm.console.The maximum borrowing amount for stable debt cannot exceed of the available liquid funds').replace("$$$", (parseFloat(_ctx.maxStableRateBorrowSizePercent.toString()) / 100).toFixed(1).toString())), 1)])) : _createCommentVNode("", true)])]),
    _: 1
  })])]), _createElementVNode("div", _hoisted_74, [_createVNode(_component_i_skeleton, {
    loading: _ctx.currentLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_75, [_createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "70%"
      }
    })])]),
    default: _withCtx(() => [$data.radio3 === 'Variable' ? (_openBlock(), _createBlock(_component_IndicatorValue, {
      key: 0,
      "old-value": _ctx.leftAvailableBorrowingAmount,
      "new-value": _ctx.afterLeftAvailableBorrowingAmount
    }, null, 8, ["old-value", "new-value"])) : _createCommentVNode("", true), $data.radio3 === 'Stable' ? (_openBlock(), _createBlock(_component_IndicatorValue, {
      key: 1,
      "old-value": _ctx.stableBorrowingAmount,
      "new-value": _ctx.afterStableBorrowingAmount
    }, null, 8, ["old-value", "new-value"])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["loading"])])]), $data.radio3 === 'Variable' ? (_openBlock(), _createElementBlock("div", _hoisted_76, [_createElementVNode("div", _hoisted_77, _toDisplayString(_ctx.$t('farm.console.VariableInterestRate')), 1), _createElementVNode("div", _hoisted_78, [_createVNode(_component_i_skeleton, {
    loading: _ctx.currentLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_79, [_createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "70%"
      }
    })])]),
    default: _withCtx(() => [_createVNode(_component_IndicatorRay, {
      suffix: "%",
      units: 2,
      "old-value": _ctx.variableBorrowSimpleRate,
      "new-value": _ctx.afterVariableRate
    }, null, 8, ["old-value", "new-value"])]),
    _: 1
  }, 8, ["loading"])])])) : _createCommentVNode("", true), $data.radio3 === 'Stable' ? (_openBlock(), _createElementBlock("div", _hoisted_80, [_createElementVNode("div", _hoisted_81, _toDisplayString(_ctx.$t('farm.console.CurrentStableInterestRate')), 1), _createElementVNode("div", _hoisted_82, [_createVNode(_component_i_skeleton, {
    loading: _ctx.currentLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_83, [_createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "70%"
      }
    })])]),
    default: _withCtx(() => [_createVNode(_component_IndicatorRay, {
      suffix: "%",
      units: 2,
      "old-value": _ctx.stableBorrowSimpleRate,
      "new-value": _ctx.stableBorrowSimpleRate
    }, null, 8, ["old-value", "new-value"])]),
    _: 1
  }, 8, ["loading"])])])) : _createCommentVNode("", true), $data.radio3 === 'Stable' ? (_openBlock(), _createElementBlock("div", _hoisted_84, [_createElementVNode("div", _hoisted_85, _toDisplayString(_ctx.$t('farm.console.StableInterestRate')), 1), _createElementVNode("div", _hoisted_86, [_createVNode(_component_i_skeleton, {
    loading: _ctx.currentLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_87, [_createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "70%"
      }
    })])]),
    default: _withCtx(() => [_createVNode(_component_IndicatorRay, {
      suffix: "%",
      units: 2,
      "old-value": _ctx.userStableSimpleRate,
      "new-value": _ctx.afterStableRate
    }, null, 8, ["old-value", "new-value"])]),
    _: 1
  }, 8, ["loading"])])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_88, [_createElementVNode("div", _hoisted_89, [_createTextVNode(_toDisplayString(_ctx.$t('farm.console.Payee')) + " ", 1), _createElementVNode("span", _hoisted_90, [_createVNode(_component_Tooltip, null, {
    default: _withCtx(() => [_createElementVNode("div", null, _toDisplayString(_ctx.$t('farm.console.PayeeTip')), 1)]),
    _: 1
  })])]), _createElementVNode("div", _hoisted_91, [_createVNode(_component_i_skeleton, {
    loading: _ctx.currentLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_92, [_createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "70%"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", {
      class: "link-text-ordinary",
      onClick: _cache[8] || (_cache[8] = $event => $options.gotoAddress(_ctx.oldOwnerShow, _ctx.$i18n.locale))
    }, [_createTextVNode(_toDisplayString(_ctx.oldOwnerShow) + " ", 1), _hoisted_93])]),
    _: 1
  }, 8, ["loading"])])]), _createElementVNode("div", _hoisted_94, [!_ctx.isConnected ? (_openBlock(), _createElementBlock("button", {
    key: 0,
    class: "btn btn-primary w-100 border-radius-20",
    type: "submit",
    onClick: _cache[9] || (_cache[9] = (...args) => $options.connectWallet && $options.connectWallet(...args))
  }, _toDisplayString(_ctx.$t('farm.console.ConnectOperatorWallet')) + " " + _toDisplayString(_ctx.isConnecting ? ' (connecting...)' : ''), 1)) : _createCommentVNode("", true), _ctx.isConnected ? (_openBlock(), _createElementBlock("div", _hoisted_95, [_createVNode(_component_el_button, {
    class: "btn btn-primary w-100 i-button",
    onClick: $options.exitReserve,
    style: _normalizeStyle({
      fontSize: _ctx.paused ? '12px !important' : '16px'
    }),
    disabled: _ctx.youAreBorrowing === 0n || !_ctx.stableRateEnabled && $data.radio3 === 'Stable' || _ctx.paused,
    loading: $data.loading || _ctx.assetsLoading
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.paused ? _ctx.$t('common.Lending Paused') : !_ctx.stableRateEnabled && $data.radio3 === 'Stable' ? _ctx.$t('farm.console.DISABLED') : $data.btnText !== '' ? $data.btnText : _ctx.$t('farm.console.Loan withdrawal btn')), 1)]),
    _: 1
  }, 8, ["onClick", "style", "disabled", "loading"]), $data.hash !== '' ? (_openBlock(), _createElementBlock("div", _hoisted_96, [_createElementVNode("img", {
    onClick: _cache[10] || (_cache[10] = $event => $options.gotoHash($data.hash, _ctx.$i18n.locale)),
    style: {
      "width": "32px"
    },
    src: _imports_2,
    alt: ""
  })])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])]);
}